<template><div>

    <div class="sort-block">
        <div class="sort-block__title">{{HaveFoundCruise(morelist.count)}}</div>
        
        <select v-model="sort" class="sort-block__select select">
            <option v-for="option in sortModes" :value="option.id" class="select__option">
                {{ option.name }}
            </option>            
        </select>
    </div>

    <template v-for="rec in morelist.list" >
        <CruiseInList :cruise="{cruiseHead:rec}" :key="rec.offer_id" :retq="retq"  />
    </template>


    <div class="load-more">
        <template v-if="!morelist.isFull && !morelist.isWait">
            <button v-if="!morelist.isFull" @click="touch_list_next" class="btn btn--blue">показать еще</button>
            <span v-if="morelist.isFail">ошибка</span>
        </template>
        <template v-else-if="morelist.isWait">
            <Loader class="loader" />
        </template>
    </div>



</div></template>

<style lang="scss" src="./Naideno.scss"></style>

<script setup>

import {ref, unRef, shallowRef, computed, onMounted} from 'vue'
import useCruiseStore from '@/cstore.js'
import {cruises_sort_key, cruises_sort_par, SORT_DEFAULT, cruise_retq_par_join} from '@/actions.js'
import CruiseInList from '@/comp/CruiseInList/CruiseInList.vue'
import Loader from '@/comp/Loader/Loader.vue'
import { HaveFoundCruise } from '@/util.js'


const sortlocal=ref({})

const сStore=useCruiseStore()
//window.сStore=сStore

const props = defineProps({
  id: String, 
})

const sortModes= [
        [SORT_DEFAULT,"Сначала ближайшие"],
        ["price","Сначала дешевые"]
    ].map( ([sort,name]) => {
        let sort_par = Object.fromEntries( cruises_sort_par({sort}) )
        return {id:sort, name, sort_par}
    } )
sortlocal.value=sortModes[0]

const sort = computed({
  get() {
    return sortlocal.value.id
  },
  set(value) {
    sortlocal.value=sortModes.find(mode => mode.id == value)
//console.log('sortlocal.value', sortlocal.value)
    touch_list_first()
  }
})


const touch_list_next = () => {
    сStore.crlistsearch_next( props.id, sortlocal.value.sort_par )
}
const touch_list_first = () => {
    сStore.crlistsearch_first( props.id, sortlocal.value.sort_par )
}


const morelist = computed( ()=>{
    let ret = сStore.crlistsearch_list( props.id, sortlocal.value.sort_par )
    return ret
})

const retq = computed( () => {
    let {ret_params} = morelist.value
    let retlist = cruise_retq_par_join( ret_params )
    return {retlist}
})

</script>
